import { render, staticRenderFns } from "./RipaFormStep6.vue?vue&type=template&id=082e49c6"
import script from "./RipaFormStep6.vue?vue&type=script&lang=js"
export * from "./RipaFormStep6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports